import React from "react";
import { Flag, Lock, Plus } from "../icons";
import { PgaFlagChip } from "./PgaFlagChip";
import type { AppliedPgaFlag } from "../lib/pga-applied";
import type { PgaCode } from "../lib/pga-schema";

export const AppliedFlagsSection: React.FC<{
  flags: AppliedPgaFlag[];
  onOpen: (code: PgaCode) => void;
  onAdd?: () => void;
  /** Disables the add affordance due to a sub-Business license, with a lock icon. */
  addLocked?: boolean;
}> = ({
  flags,
  onOpen,
  onAdd,
  addLocked,
}) => {
  const empty = flags.length === 0;
  return (
    <section className="ih-col ih-gap-2">
      <div className="ih-row ih-between ih-gap-2">
        <div className="ih-row ih-gap-1">
          <Flag size={14} className="ih-tone-info" />
          <h4 className="ih-kicker" style={{ fontSize: 12, fontWeight: 600 }}>Applied PGA Flags</h4>
          <span className="ih-text-xs ih-text-muted ih-num">({flags.length})</span>
        </div>
      </div>
      {empty && !onAdd && (
        <div className="ih-subsurface ih-text-xs ih-text-muted ih-italic ih-text-center" style={{ padding: "16px 12px" }}>
          No PGA flags applied yet. Select applicable hits below to add flags.
        </div>
      )}
      {empty && onAdd && (
        <button
          type="button"
          onClick={addLocked ? undefined : onAdd}
          disabled={addLocked}
          title={addLocked ? "Requires a Business license" : undefined}
          className="ih-pga-add-empty"
          aria-label="Create program code flag"
        >
          {addLocked ? <Lock size={16} /> : <Plus size={16} />}
          <div className="ih-col" style={{ alignItems: "flex-start" }}>
            <span className="ih-font-semibold ih-text-xs">Add program code flag</span>
            <span className="ih-text-xs ih-text-muted">
              Create manually or apply a hit from the screening table below.
            </span>
          </div>
        </button>
      )}
      {!empty && (
        <div className="ih-pga-flag-grid">
          {flags.map((f) => (
            <PgaFlagChip key={f.code} code={f.code} flag={f} onClick={() => onOpen(f.code)} />
          ))}
          {onAdd && (
            <button
              type="button"
              onClick={addLocked ? undefined : onAdd}
              disabled={addLocked}
              title={addLocked ? "Requires a Business license" : undefined}
              className="ih-pga-add-tile"
              aria-label="Create program code flag"
            >
              {addLocked ? <Lock size={18} /> : <Plus size={18} />}
              <span className="ih-pga-add-tile-label">Add flag</span>
            </button>
          )}
        </div>
      )}
    </section>
  );
}
